'use strict';

import "./modules/nav";
import "./modules/resizeTimer";
import "./modules/fadeInOnScroll";
import "./modules/numberCounterOnScroll";
import "./modules/anchors";
import "./modules/glide";
import { modal } from "./modules/modal";
modal();

document.addEventListener("DOMContentLoaded", function() {
  // Hubspot cookie settings links in footer
  const hubspotCookieSettings = document.getElementById('hs-footer-cookie-settings');
  if (hubspotCookieSettings) {
    hubspotCookieSettings.addEventListener('click', function(e) {
      e.preventDefault();
      var _hsp = window._hsp = window._hsp || [];
      _hsp.push(['showBanner']);
    });
  }
});

